import { createNamespacedHelpers } from 'vuex';
import BaseStore from '@/store';
import actions from './cargoCarriers.actions.js';
import mutations from './cargoCarriers.mutations.js';
import state from './cargoCarriers.state.js';
import getters from './cargoCarriers.getters';

BaseStore.registerModule('cargoCarriers', {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
});

export default BaseStore;

let { mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('cargoCarriers');

export {
	mapState,
	mapGetters,
	mapMutations,
	mapActions
};
